<template>
  <div>
    <v-overlay :value="showAssignBadge" class="d-flex">
      <div class="d-flex justify-end">
        <v-btn icon @click="showAssignBadge = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <badge-select v-on:badge:select="selectBadge"></badge-select>
    </v-overlay>

    <base-badge
      badgeIcon="mdi-pencil"
      badgeColor="green"
      :imageUrl="badgeUrl"
      class="center-align"
      style="padding-top: 10px;"
      v-on:badge:click="showAssignBadge = true"
    ></base-badge>

    <base-learning-edit
      :id="item.id"
      :initialBody="item.body"
      :initialName="item.name"
      :initialDescription="item.description"
    />
    <h3 class="my-4">Resource Documents</h3>
    <documents-tree
      :documents="editDocuments"
      :allowDelete="true"
      :allowEdit="true"
      :allowFolders="false"
    ></documents-tree>
    <document-upload :resourceParentId="item.id" />
    <base-learning-responses-edit
      :manager="true"
      :itemId="item.id"
      :responses="responses"
    />
  </div>
</template>
<script>
import BaseLearningEdit from "@/components/BaseLearningEdit"
import BaseLearningView from "@/components/BaseLearningView"
import BaseLearningResponsesComplete from "@/components/BaseLearningResponsesComplete"
import BaseLearningResponsesEdit from "@/components/BaseLearningResponsesEdit"
import BaseLearningResponseView from "@/components/BaseLearningResponseView"
import BaseList from "@/components/BaseList"
import BaseBadge from "@/components/BaseBadge"
import BadgeSelect from "@/containers/badges/BadgeSelect"
import BaseGrid from "@/components/BaseGrid"
import { DocumentsAPI } from "@/lib/api"
import DocumentUpload from "@/containers/documents/DocumentUpload"
import DocumentsTree from "@/components/DocumentsTree"
import eventMixin from "@/mixins/eventMixin"
import User from "@/lib/user"

export default {
  mixins: [eventMixin],
  components: {
    BaseLearningEdit,
    BaseLearningView,
    BaseLearningResponsesComplete,
    BaseLearningResponsesEdit,
    BaseLearningResponseView,
    BaseList,
    BaseBadge,
    BadgeSelect,
    BaseGrid,
    DocumentUpload,
    DocumentsTree
  },
  props: {
    item: { type: Object, default: () => {} },
    responsesComplete: { type: Boolean, default: false }
  },
  watch: {
    documents: function(val) {
      this.editDocuments = JSON.parse(JSON.stringify(val))
    }
  },
  computed: {
    responses() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.item.id
      )
      return item && item.responses ? item.responses : []
    },
    badgeUrl() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.item.id
      )
      return item ? item.badge_url : ""
    },
    documents() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.item.id
      )
      return item ? item.documents : []
    }
  },
  data() {
    return {
      edit: false,
      showAssignBadge: false,
      userType: User.getUserType(),
      editDocuments: []
    }
  },
  methods: {
    toggleRelease(item) {
      this.$store.dispatch("learningItems/updateLearningItem", {
        id: item.id,
        hidden: !item.hidden
      })
    },
    selectBadge(badge) {
      this.$store.dispatch("learningItems/updateLearningItem", {
        id: this.item.id,
        badgeId: badge.id
      })
      this.showAssignBadge = false
    }
  },
  created() {
    this.addListener("list:removeItem", itemId => {
      DocumentsAPI.delete(itemId).then(() => {
        this.$store.dispatch("learningItems/loadLearningItems")
      })
    })

    this.addListener("DocumentAdded", () => {
      this.$store.dispatch("learningItems/loadLearningItems")
    })

    this.addListener("tree:updateItem", item => {
      DocumentsAPI.update(item).then(() => {
        // this.getDocuments()
      })
    })

    // this.getDocuments()
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
.center-align {
  display: flex;
  justify-content: center;
}
</style>
